import { jsx as _jsx } from "react/jsx-runtime";
import { _className } from '../../utils/tools.js';
import { TS_BaseInput } from './TS_BaseInput.js';
import './TS_Input.scss';
/**
 * A better way to capture user input
 *
 * <code>
 * 		<input className="ts-input"/>
 * </code>
 *
 */
export class TS_Input extends TS_BaseInput {
    static defaultProps = {
        forceAcceptKeys: ['ctrlKey', 'metaKey']
    };
    onKeyDown = (ev) => {
        let value = ev.currentTarget.value;
        if (!(ev.shiftKey || ev.altKey || ev.ctrlKey || ev.metaKey)) {
            if (ev.key === 'Enter') {
                ev.persist();
                if (this.props.trim)
                    value = value.trim();
                //@ts-ignore - despite what typescript says, ev.target does have a blur function.
                ev.target.blur();
                if (this.props.onAccept) {
                    if (value !== this.props.value)
                        this.props.onAccept(value, ev);
                    ev.stopPropagation();
                }
            }
            if (ev.key === 'Escape' && this.props.onCancel) {
                this.props.onCancel();
                ev.stopPropagation();
            }
        }
        if (ev.key === 'Enter' && this.props.forceAcceptKeys?.find(key => ev[key]))
            if (this.props.onAccept) {
                if (value !== this.props.value)
                    this.props.onAccept(value, ev);
                ev.stopPropagation();
            }
        this.props.onKeyDown?.(ev);
    };
    render() {
        const { onAccept, innerRef, trim, forceAcceptKeys, focus, ...props } = this.props;
        return _jsx("input", { ...props, autoFocus: focus, ref: innerRef, onBlur: (event) => {
                const value = event.target.value;
                this.setState({ value });
                props.onBlur?.(value, event);
            }, name: props.name || props.id, placeholder: this.state.placeholder, className: _className('ts-input', props.disabled ? 'disabled' : undefined, props.className), value: this.state.value, onChange: this.changeValue, onKeyDown: this.onKeyDown, autoComplete: props.autoComplete ? 'on' : 'off', disabled: props.disabled });
    }
}
//# sourceMappingURL=TS_Input.js.map